import { API_ENDPOINTS } from '../../constants/api';
import axios from 'axios';
import { fetchCurrentCart } from './get';
import { createAction } from 'redux-actions';
import { showBanner } from '../banner/reveal';
import bundleMap from './bundles';

const actions = {
  add: createAction('CART.ADD_TO_CART'),
  success: createAction('CART.ADD_TO_CART_SUCCESS'),
  error: createAction('CART.ADD_TO_CART_ERROR'),
};

/**
 * Add to cart
 * Refer to https://shopify.dev/docs/themes/ajax-api/reference/cart
 * @param url
 * @param properties
 * @returns {Promise<any>}
 */
const addToCart = async (url, properties) => {
  try {
    const { data } = await axios.post(url, properties);
    return data;
  } catch (error) {
    throw new Error(error);
  }
};

/**
 * Start the addToCart request
 * @param {object} data - properties to be passed to the add to cart post request
 * @param {string} addedProduct - name of product that was added to the cart
 * @returns {function(...[*]=)}
 */
export const initializeAddToCart = (data, addedProduct) => {
  return async (dispatch) => {
    dispatch(actions.add());

    let items = Array.isArray(data) ? data : [data];

    const bundles = bundleMap[window.Shopify.shop];
    if (bundles) {
      items = items.map((item) => {
        const bundle = bundles.find((b) => b.variant_id.toString() === item.id.toString());
        if (bundle) {
          return bundle.items.map((item) => ({ quantity: 1, id: item.variant_id }));
        }
        return item;
      });
    }

    const properties = {
      items: items.flat(),
    };

    try {
      await addToCart(API_ENDPOINTS.cart.add, properties);
      dispatch(actions.success());
      dispatch(fetchCurrentCart());
      dispatch(showBanner(addedProduct));
    } catch (error) {
      dispatch(actions.error(error));
    }
  };
};

export default actions;
